import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";
import { InspImageState, FetchAiImageParams, useInspImage } from "../hooks/useInspImage";

export interface InspImageValue extends InspImageState {
  fetchAiImgData: (params: FetchAiImageParams) => Promise<void>;
  reset: () => void;
  visibleIndex: number | null;
  setVisibleIndex: (index: number | null) => void;
}

const InspImageContext = createContext<InspImageValue | null>(null);

interface InspImageProviderProps {
  serverAddress: string | undefined;
  trainUuid: string | undefined;
  children: ReactNode;
}

export function InspImageProvider({ serverAddress, trainUuid, children }: InspImageProviderProps) {
  const image = useInspImage(serverAddress, trainUuid);
  const [visibleIndex, setVisibleIndex] = useState<number | null>(null);

  useEffect(() => {
    setVisibleIndex(null);
  }, [image.data]);

  const value = useMemo<InspImageValue>(() => ({ ...image, visibleIndex, setVisibleIndex }), [image, visibleIndex]);

  return <InspImageContext.Provider value={value}>{children}</InspImageContext.Provider>;
}

export function useInspImageContext(): InspImageValue {
  const ctx = useContext(InspImageContext);
  if (!ctx) {
    throw new Error("useInspImageContext는 InspImageProvider 안에서만 사용할 수 있습니다.");
  }
  return ctx;
}
